<template lang="html">
    <aside>
        <div class="sticky-top">
            <section>
                <b-form-group label="Cluster" description="Selecteer cluster">
                    <b-form-select v-model="settings.global.cluster" @change="loadCluster">
                        <b-form-select-option value="cluster_1">Cluster 1</b-form-select-option>
                        <b-form-select-option value="cluster_2">Cluster 2</b-form-select-option>
                        <b-form-select-option value="cluster_3">Cluster 3</b-form-select-option>
                    </b-form-select>
                </b-form-group>
            </section>
            <section>
                <div class="d-flex align-items-center mb-0">
                    <h5 @click="collapse.global = !collapse.global">Daginstellingen</h5>
                    <b-button variant="button" class="ml-auto" @click="collapse.global = !collapse.global">
                        <b-icon icon="chevron-down" shift-v="2" v-if="collapse.global" font-scale="0.95"></b-icon>
                        <b-icon icon="chevron-up" shift-v="2" v-if="!collapse.global" font-scale="0.95"></b-icon>
                    </b-button>
                </div>
                <b-collapse id="global" v-model="collapse.global">
                    <b-form-group class="mt-3">
                        <b-form-checkbox id="checkbox-1" name="checkbox-1" v-model="settings.global.holiday" @change="setHoliday($event)">
                            Vakantie/vrije dag?
                        </b-form-checkbox>
                    </b-form-group>
                    <b-form-group label="Titel" description="Geef dag(en) een titel">
                        <b-form-input v-model="settings.global.title" @keyup="setTitle" />
                    </b-form-group>
                </b-collapse>
            </section>
            <section>
                <div class="d-flex align-items-center mb-0">
                    <h5 @click="collapse.lesson = !collapse.lesson">Lesinstellingen</h5>
                    <b-button variant="button" class="ml-auto" @click="collapse.lesson = !collapse.lesson">
                        <b-icon icon="chevron-down" shift-v="2" v-if="collapse.lesson" font-scale="0.95"></b-icon>
                        <b-icon icon="chevron-up" shift-v="2" v-if="!collapse.lesson" font-scale="0.95"></b-icon>
                    </b-button>
                </div>
                <b-collapse v-model="collapse.lesson">
                    <b-form-group label="Type" description="Selecteer lestype" class="mt-3">
                        <v-select :options="types" :reduce="(types) => types.value" value="oude_testament" v-model="settings.lesson.type" @input="setLessonStart"/>
                    </b-form-group>
                    <b-form-group label="Start vanaf" description="Selecteer vanaf welke les u wilt starten">
                        <v-select label="titel" :options="lessonsOfType" v-model="settings.lesson.start">
                            <template #selected-option="{ titel, nummer }"><span>{{ nummer }} - {{ titel }}</span></template>
                            <template #option="{ titel, nummer }"><span>{{ nummer }} - {{ titel }}</span></template>
                        </v-select>
                    </b-form-group>

                    <b-form-group label="Bewerk optie">
                        <b-form-select v-model="overwriteLessons">
                            <option :value="0">Lessen behouden</option>
                            <option :value="1">Lessen overschrijven</option>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group>
                        <b-button class="ml-auto" @click="setLessons" variant="primary">Lessen aanmaken</b-button>
                        <b-button class="ml-auto" @click="resetLessons" variant="danger">Lessen wissen</b-button>
                    </b-form-group>
                </b-collapse>
            </section>
            <section>
                <div class="d-flex align-items-center mb-0">
                    <h5 @click="collapse.colors = !collapse.colors">Kleurinstellingen</h5>
                    <b-button variant="button" class="ml-auto" @click="collapse.colors = !collapse.colors">
                        <b-icon icon="chevron-down" shift-v="2" v-if="collapse.colors" font-scale="0.95"></b-icon>
                        <b-icon icon="chevron-up" shift-v="2" v-if="!collapse.colors" font-scale="0.95"></b-icon>
                    </b-button>
                </div>
                <b-collapse v-model="collapse.colors">
                    <b-form-group class="mt-3" label="Achtergrondkleur" description="Kies een achtergrondkleur">
                        <v-swatches
                            v-model="settings.color.background"
                            :inline="true"
                            :swatch-size="29"
                            :shapes="'circles'"
                            :showBorder="true"
                            :background-color="'transparent'"
                            :swatches="themeColors"
                            @input="setBackgroundColor"
                        />
                    </b-form-group>
                    <b-form-group label="Tekstkleur" description="Kies een tekstkleur">
                        <v-swatches
                            v-model="settings.color.text"
                            :inline="true"
                            :swatch-size="29"
                            :shapes="'circles'"
                            :showBorder="true"
                            :background-color="'transparent'"
                            :swatches="themeColors"
                            @input="setTextColor"
                        />
                    </b-form-group>
                </b-collapse>
            </section>
            <section>
                <div class="d-flex align-items-center mb-0">
                    <h5 @click="collapse.export = !collapse.export">Exporteren</h5>
                    <b-button variant="button" class="ml-auto" @click="collapse.export = !collapse.export">
                        <b-icon icon="chevron-down" shift-v="2" v-if="collapse.export" font-scale="0.95"></b-icon>
                        <b-icon icon="chevron-up" shift-v="2" v-if="!collapse.export" font-scale="0.95"></b-icon>
                    </b-button>
                </div>
                <b-collapse v-model="collapse.export">
                    <b-form-group class="mt-3" label="XLSX" description="Exporteren als xlsx document (excel)">
                        <b-button variant="primary" @click="exportXlsx">
                            Exporteren naar Excel
                            <b-icon icon="file-spreadsheet" class="ml-3"></b-icon>
                        </b-button>
                    </b-form-group>
                    <b-form-group label="Printen" description="Roosters printen">
                        <b-button variant="primary" @click="print">
                            Print rooster
                            <b-icon icon="printer" class="ml-3"></b-icon>
                        </b-button>
                    </b-form-group>
                </b-collapse>
            </section>
            <section>
                <b-form-group label="Wizard">
                    <b-button variant="secondary" @click="$router.push({ name: 'home', params: { stepId: 1 }})">
                        <b-icon icon="chevron-left" shift-v="2" font-scale="0.95"></b-icon>    Terug naar wizard
                    </b-button>
                </b-form-group>
            </section>
            <section>
                <b-form-group label="Geschiedenis" description="Als u uw data verwijdert kan het daarna niet worden teruggehaald">
                    <p>Ervaart u verkeerde data/vakken in het rooster verwijder dan je geschiedenis en probeer het opniew</p>
                    <b-button variant="secondary" @click="clearCache">Alle gegevens wissen</b-button>
                </b-form-group>
            </section>
        </div>
    </aside>
</template>

<script>
import VSwatches from 'vue-swatches';
import Excel from 'exceljs';
import Lessons from '../modules/lesson2.module';
import { mapGetters } from 'vuex';

export default {
    name: 'Sidebar',
    props: ['selection', 'settings'],
    data() {
        return {
            collapse: {
                global: false,
                lesson: false,
                colors: false,
                export: false,
            },
            clusterOptions: [
                'cluster_1',
                'cluster_2',
                'cluster_3',
            ],
            overwriteLessons: 0,
            localIndexes: {},
        };
    },
    mounted() {
        this.$root.$on('parse:selection', this.setModelsBasedOnSelection);
    },
    computed: {
        clusterIndex() {
            return this.clusterOptions.indexOf(this.settings.global.cluster);
        },
        cluster() {
            return this.settings.clusters[this.settings.global.cluster];
        },
        types: {
            get() {
                const keys = Object.keys(this.cluster);
                const items = [];
                keys.forEach((k) => {
                    const text = k.split('_').map((part) => {
                        return part[0].toUpperCase() + part.substring(1);
                    }).join(' ');
                    items.push({ label: text, value: k });
                });
                return items;
            },
        },
        lessonsOfType() {
            return this.cluster[this.settings.lesson.type];
        },
        themeColors: {
            get() {
                const style = getComputedStyle(document.body);
                const theme = [
                    '#8000ff',
                    style.getPropertyValue('--secondary'),
                    style.getPropertyValue('--success'),
                    style.getPropertyValue('--info'),
                    style.getPropertyValue('--warning'),
                    style.getPropertyValue('--danger'),
                    '#000',
                    '#fff',
                ];

                return theme;
            },
        },
        ...mapGetters([
            'rooster/cluster'
        ]),
    },
    methods: {
        clearCache() {
            if (confirm('Weet je zeker dat je de gegevens wilt wissen? Hiermee worden alle instellingen en data verwijderd.')) {
                localStorage.clear();
                location.reload();
            }
        },
        loadCluster() {
            this.$parent.$emit('update:cluster', this.settings.global.cluster);
        },
        setModelsBasedOnSelection(selection) {
            const hasHolidays = selection.find((component) => component.data.holiday);
            const hasTitle = selection.find((component) => component.title);

            if (hasHolidays) {
                this.settings.global.holiday = hasHolidays.data.holiday;
                this.settings.global.title = hasHolidays.title;
            } else {
                this.settings.global.holiday = false;
                this.settings.global.title = '';
            }

            if (hasTitle) {
                this.settings.global.title = hasTitle.title;
            } else {
                this.settings.global.title = '';
            }
        },
        setHoliday(isHoliday) {
            this.selection.forEach((component) => {
                if (isHoliday) {
                    component.day.setHoliday(this.settings.global.title);
                } else {
                    component.day.removeHoliday();
                }
            });
        },
        setTitle() {
            this.selection.forEach((component) => (component.day.localTitle = this.settings.global.title));
        },
        setLessonStart() {
            const local = this.localIndexes[this.clusterIndex + '-' + this.settings.lesson.type];
            const index = local > 0 ? local : this["rooster/cluster"](this.clusterIndex)[this.settings.lesson.type];
            const lesson = this.lessonsOfType[index];
            if (lesson) {
                this.settings.lesson.start = lesson;
            }
        },
        setLessons() {
            let startIndex = Lessons.getIndexByNumber(this.settings.global.cluster, this.settings.lesson.type, this.settings.lesson.start.nummer);
            this.selection.forEach((component) => {
                const date = component.day.localDate.format('YYYY-MM-DD');
                if (!!component.day.localTitle && !this.overwriteLessons) {
                    return console.log('%s already has a localTitle and overwrite is false', date);
                } else {
                    component.day.autofill(this.settings.global.cluster, this.settings.lesson.type, startIndex, true, this.overwriteLessons, this.overwriteLessons);
                    if (component.day.isFriday() && component.day.hasVerwerking()) {
                        component.day.setVerwerking();
                    }
                    if (!component.day.isHoliday() && !component.day.isFriday()) {
                        startIndex++;
                    }
                }
            });
            this.localIndexes[this.clusterIndex + '-' + this.settings.lesson.type] = startIndex;
            this.settings.lesson = {};
        },
        setTextColor() {
            this.selection.forEach((component) => (component.day.localTextColor = this.settings.color.text));
        },
        setBackgroundColor() {
            this.selection.forEach((component) => (component.day.localBackgroundColor = this.settings.color.background));
        },
        async exportXlsx() {
            const workbook = new Excel.Workbook();
            const sheets = this.$parent.clusters.map((cluster) => workbook.addWorksheet(cluster.name));
            const fontName = 'Segoe UI';

            sheets.forEach((sheet, sheetIndex) => {
                sheet.columns = [
                    { header: 'Week', width: 15 },
                    { header: 'Maandag', width: 35 },
                    { header: 'Dinsdag', width: 35 },
                    { header: 'Woensdag', width: 35 },
                    { header: 'Donderdag', width: 35 },
                    { header: 'Vrijdag', width: 35 },
                ];

                sheet.getRow(1).eachCell((cell) => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: `00CECECE` },
                    };
                    cell.font = {
                        name: fontName,
                        size: 11,
                        color: {
                            argb: '00000000',
                        },
                    };
                    cell.alignment = {
                        vertical: 'middle',
                    };
                });

                this.$parent.clusters[sheetIndex].data.forEach((week, wi) => {
                    let row = sheet.getRow(wi + 2);
                    row.getCell(1).value = `Week ${week.index}`;
                    week.days.forEach((day, di) => {
                        let cell = row.getCell(di + 2);
                        cell.value = day.localTitle;
                        if (cell.value == null) {
                            cell.value = day.localTitles.join(" ");
                        }
                        else {
                            cell.value += " " + day.localTitles.join(" ");
                        }

                        if (day.localBackgroundColor) {
                            let fgColor = day.localBackgroundColor.replace(/[\s#]+/, '');
                            fgColor = fgColor.length === 3 ? fgColor.replace(/[\s#]+/, '').repeat(2) : fgColor.replace(/[\s#]+/, '');

                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: `00${fgColor}` },
                            };
                            cell.font = {
                                name: fontName,
                                size: 11,
                                color: {
                                    argb: '000000',
                                },
                            };
                            cell.alignment = {
                                vertical: 'middle',
                            };
                        }

                        if (day.localTextColor) {
                            let color = day.localTextColor.replace(/[\s#]+/, '');
                            color = color.length === 3 ? color.replace(/[\s#]+/, '').repeat(2) : color.replace(/[\s#]+/, '');

                            cell.font.color.argb = `00${color}`;
                        }
                    });
                });
            });

            // write to a new buffer
            const buffer = await workbook.xlsx.writeBuffer();

            var blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            var fileName = 'RoosterHHW.xlsx';
            link.download = fileName;
            link.click();
        },
        print() {
            window.print();
        },
        resetLessons() {
            this.selection.forEach((component) => {
                component.reset();
                component.$el.parentNode.classList.remove('selected');
                component.$el.parentNode.classList.remove('selecting');
            });
            this.settings.lesson = {};
        },
    },
    components: {
        VSwatches,
    },
};
</script>
